/**
 * Collect form values and trigger ajax request 
 * @return void
 */
function refreshLottoQuicktippTotalAmount(){
    console.log("refreshLottoQuicktippTotalAmount");

    var submitBtn = $("#button-to-basket");
    var submitBtnIsDisabled = submitBtn.prop("disabled");

    // Collect form values
    var data = {
        "drawingDays": $('input[type=radio][name="drawing_day"]:checked').attr("data-label"),
        "duration": $("#laufzeit").data("duration"),
        "spiel77": $("#input-spiel77").prop("checked") ? true : false,
        "super6": $("#input-super6").prop("checked") ? true : false,
        "lottoReihen": $("#spiel-reihen").data("rows"),
        "SpielscheinTypId" : "1"
    }

    submitBtn.prop("disabled", true);
    $("#totalAmount").html(calculateAmount(data));

    if (!submitBtnIsDisabled) {
        submitBtn.prop("disabled", false);
    }
}